import { compose, withProps, withState, withHandlers } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import withEventListener from 'components/common/hoc/withEventListener'
import { OPEN_TRUMPET_REVIEWS_TAB, STORE_LOCATOR_MODAL_PAGE } from 'constant'
import { TABS, REVIEWS_TAB_INDEX, SERVICES_TAB_INDEX, BOT_STORE_INFORMATION_TYPE, STORE_ID_FOR_STAGE_REVIEWS } from '../constants'
import { isServiceCategoryURL, getStoreBaseURL, isProductionEnvironment } from '../helpers'
import StoreDetailsPage from './StoreDetailsPage'
import { processStoreNumFromURL } from 'helpers/storeLocator'
import { getLocationPathname } from 'selectors/getPageLocation'
import { showStoreLocatorModal } from 'actions/storeLocator'

const mapStateToProps = state => {
  const pathname = getLocationPathname(state) || ''
  return {
    pathname,
    isServiceCategory: isServiceCategoryURL(pathname)
  }
}

const withReviewsTabVisitedState = withState('reviewsTabVisited', 'setReviewsTabVisited', false)

const withStoreTabsProps = withProps(({ isServiceCategory }) => ({
  eventName: OPEN_TRUMPET_REVIEWS_TAB,
  reviewsTabIndex: REVIEWS_TAB_INDEX,
  initialTabIndex: isServiceCategory ? SERVICES_TAB_INDEX : 0,
  tabs: TABS
}))

const withStoreTabsHandlers = withHandlers({
  onTabChangedCallback: ({ reviewsTabVisited, setReviewsTabVisited }) => tabIndex =>
    !reviewsTabVisited && tabIndex === REVIEWS_TAB_INDEX && setReviewsTabVisited(true)
})

const withStoreNumber = withProps(({ mainContent = [], pathname }) => {
  const {
    storeInformation: {
      storeNum
    } = {}
  } = (mainContent.find(item => item['@type'] === BOT_STORE_INFORMATION_TYPE) || {})
  return {
    storeNum: processStoreNumFromURL(getStoreBaseURL(pathname)) || storeNum
  }
})

const withGlobalEventHandler = withEventListener({
  eventName: STORE_LOCATOR_MODAL_PAGE,
  getHandler: ({ showStoreLocatorModal }) => () => showStoreLocatorModal()
})

const withOrganizedPlaceholders = withProps(({
  placeholders: {
    mainContent = []
  } = {},
  storeNum
}) => {
  const organizedPlaceholders = {
    StoreDetailsTop: [],
    tabs: {}
  }
  const tabItems = {
    BOTStoreDeals: 'StoreDeals',
    BOTStoreServices: 'StoreServices'
  }
  mainContent.forEach(item => {
    if (tabItems[item.props.type]) {
      organizedPlaceholders.tabs[tabItems[item.props.type]] = item
    } else if (item.props.type !== 'BOTStoreAmenities') { // Amenities getting filtered out here.
      organizedPlaceholders.StoreDetailsTop.push(item)
    }
  })

  return {
    organizedPlaceholders,
    storeIdForTrustmary: isProductionEnvironment() ? storeNum : STORE_ID_FOR_STAGE_REVIEWS
  }
})

export default compose(
  withType({ type: 'StoreDetailsOneColumnPage', placeholders: ['footer', 'header', 'mainContent']}),
  connect(mapStateToProps, { showStoreLocatorModal }),
  withReviewsTabVisitedState,
  withStoreTabsProps,
  withStoreTabsHandlers,
  withStoreNumber,
  withGlobalEventHandler,
  withOrganizedPlaceholders
)(StoreDetailsPage)
